import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Menu, X } from "lucide-react";
import logo from "../assets/logo.png";
import logoWhite from "../assets/logo-white.png";

export default function Navbar() {
  const [isOpen, setIsOpen] = useState(false);
  const [isScrolled, setIsScrolled] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 10);
    };

    window.addEventListener("scroll", handleScroll);
    handleScroll();

    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  const navLinks = [
    { name: "Главная", path: "/" },
    { name: "О нас", path: "/about" },
    { name: "Наши проекты", path: "/projects" },
    { name: "Контакты", path: "/contact" },
  ];

  return (
    <nav
      className={`fixed top-0 left-0 w-full z-50 transition-all duration-300 ${
        isScrolled ? "bg-white shadow-lg" : "bg-transparent shadow-none"
      }`}
    >
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex justify-between items-center h-20">
          <Link to="/" className="flex items-center gap-2">
            <img
              src={isScrolled ? logo : logoWhite}
              alt="bart-group"
              className="w-[100px]"
            />
          </Link>

          <div className="hidden md:flex items-center gap-8">
            {navLinks.map((link) => (
              <Link
                key={link.path}
                to={link.path}
                className={`font-semibold transition-colors relative group ${
                  isScrolled
                    ? "text-slate-800 hover:text-[#147f8f]"
                    : "text-white hover:text-[#147f8f]"
                }`}
              >
                {link.name}

                <span className="absolute -bottom-2 left-0 w-0 h-[2px] bg-[#147f8f] group-hover:w-full transition-all duration-300"></span>
              </Link>
            ))}

            <Link
              to="/contact"
              className={`px-6 py-3 rounded-sm font-semibold transition-all ${
                isScrolled
                  ? "bg-[#147f8f] hover:bg-[#093b43] text-white"
                  : "bg-white text-slate-900 hover:bg-[#147f8f] hover:text-white"
              }`}
            >
              Получить предложение
            </Link>
          </div>

          <button
            onClick={() => setIsOpen(!isOpen)}
            className={`md:hidden transition-colors ${
              isScrolled ? "text-slate-900" : "text-white"
            }`}
            aria-label="Toggle navigation menu"
          >
            {isOpen ? <X className="w-6 h-6" /> : <Menu className="w-6 h-6" />}
          </button>
        </div>

        {isOpen && (
          <div className="md:hidden bg-white pb-4 border-t">
            {navLinks.map((link) => (
              <Link
                key={link.path}
                to={link.path}
                className="block px-4 py-3 text-slate-700 hover:bg-[#093b43] hover:text-white transition-colors"
                onClick={() => setIsOpen(false)}
              >
                {link.name}
              </Link>
            ))}

            <Link
              to="/contact"
              className="block mx-4 mt-2 bg-[#147f8f] hover:bg-[#093b43] text-white px-6 py-3 rounded-lg font-semibold transition-colors text-center"
              onClick={() => setIsOpen(false)}
            >
              Получить предложение
            </Link>
          </div>
        )}
      </div>
    </nav>
  );
}